import type { ExcalidrawFontFaceDescriptor } from "../Fonts";

// Using Google Fonts CDN for Poppins
export const PoppinsFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: "https://fonts.gstatic.com/s/poppins/v21/pxiEyp8kv8JHgFVrJJfecnFHGPc.woff2",
    descriptors: { style: "normal", weight: "400" },
  },
  {
    uri: "https://fonts.gstatic.com/s/poppins/v21/pxiByp8kv8JHgFVrLGT9Z1xlFd2JQEk.woff2",
    descriptors: { style: "normal", weight: "500" },
  },
  {
    uri: "https://fonts.gstatic.com/s/poppins/v21/pxiByp8kv8JHgFVrLEj6Z1xlFd2JQEk.woff2",
    descriptors: { style: "normal", weight: "600" },
  },
  {
    uri: "https://fonts.gstatic.com/s/poppins/v21/pxiByp8kv8JHgFVrLCz7Z1xlFd2JQEk.woff2",
    descriptors: { style: "normal", weight: "700" },
  },
];